import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_3 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "Danh sách đề tài" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          value: $setup.dsDeTai,
          paginator: true,
          stripedRows: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          rowHover: true,
          filters: $setup.filters,
          "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          globalFilterFields: ['tenDeTai','noiDungDeTai'],
          currentPageReportTemplate: "Có tổng số {totalRecords} đề tài",
          columnResizeMode: "fit | expand"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Button, {
                type: "button",
                icon: "pi pi-filter-slash",
                label: "Xoá",
                class: "p-button-outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter())),
                style: {"width":"6em"}
              }),
              _createElementVNode("span", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputText, {
                  modelValue: $setup.filters['global'].value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                  placeholder: "Tìm kiếm"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "tenDeTai",
              header: "Tên đề tài",
              sortable: "",
              style: {"width":"20vw","font-weight":"bolder"}
            }),
            _createVNode(_component_Column, {
              field: "noiDungDeTai",
              header: "Nội dung đề tài",
              sortable: "",
              style: {"width":"50vw"}
            }),
            _createVNode(_component_Column, { header: "" }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_router_link, {
                  style: {"text-decoration":"none !important"},
                  to: { name: 'chitietdetai', params: {id: slotProps.data.id}}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Button, {
                      type: "button",
                      label: "Xem chi tiết",
                      icon: "pi pi-pencil"
                    })
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"])
      ])
    ]),
    _: 1
  }))
}